import React from 'react'
import { TranslationText } from 'components/TextTranslationContainer';
import ButtonSpinner from 'components/ButtonSpinner';

const PaybyPaymentComplete =({ status, timer, paymentRef }) => {
    // const formatTime = (seconds) => {
    //   const minutes = Math.floor(seconds / 60);
    //   const remainingSeconds = seconds % 60;
    //   return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    // };
  
    const config = {
      PENDING: {
        title: 'Confirming your payment...',
        description: 'Please wait while we confirm your payment',
      },
      PAID_SUCCESS: {
        title: 'Payment confirmed!',
        description: 'Your payment has been confirmed',
      },
      SETTLED: {
        title: 'Payment confirmed!',
        description: 'Your payment has been confirmed',
      },
      FAILURE: {
        title: 'Payment confirmation failed',
        description: 'Please contact customer support',
      },
    }
  
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-6 gap-4">
        <ButtonSpinner height="50" width="50" color="text-brand-base-primary" />
        <TranslationText text={config[status]?.title ?? config?.PENDING?.title} as="h4" className="capitalize" />
        <TranslationText text={config[status]?.description ?? config?.PENDING?.description} as="p" className="capitalize" />
       {paymentRef && <TranslationText text={`Payment Reference:`} contentProps={{ paymentRef }} as="p" className="capitalize" />}
      </div>
    );
  };

export default PaybyPaymentComplete